
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56.725 56.723"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"door(1)","fill":"#3d9ed3"}},[_c('path',{attrs:{"data-name":"Path 7074","d":"M55.749 51.886h-7.583V3.863a.973.973 0 00-.865-.967l-25.6-2.89a.974.974 0 00-1.083.968v1.915H9.53a.974.974 0 00-.974.974v48.023H.974a.974.974 0 100 1.948h19.641v1.915a.974.974 0 00.974.974.9.9 0 00.111-.006l25.547-2.883h8.5a.974.974 0 100-1.948zM10.504 4.837h10.111v2.5h-6.632a.974.974 0 00-.974.974v43.575h-2.5zm4.452 47.049v-42.6h5.658v42.6zm7.606-49.822l23.655 2.672V51.99l-23.654 2.671z"}}),_c('path',{attrs:{"data-name":"Path 7075","d":"M26.762 25.463a2.9 2.9 0 102.9 2.9 2.9 2.9 0 00-2.9-2.9zm0 3.849a.951.951 0 11.951-.951.951.951 0 01-.951.951z"}})])])
          )
        }
      }
    